export function inArray<T>(value: T, array: T[]): boolean {
    return array.indexOf(value) >= 0;
}

export function findIndex<T>(array: T[], predicate: (item: T, index: number) => boolean): number | undefined {
    for (let i = 0; i < array.length; i++) {
        const value = array[i];
        if (predicate(value, i)) {
            return i;
        }
    }
}

export function findIndexes<T>(array: T[], predicate: (item: T, index: number) => boolean): number[] {
    const result: number[] = [];
    for (let i = 0; i < array.length; i++) {
        const value = array[i];
        if (predicate(value, i)) {
            result.push(i);
        }
    }
    return result;
}

export function findFirst<T>(array: T[], predicate: (item: T, index: number) => boolean): T | undefined {
    const index = findIndex(array, predicate);
    if (typeof index !== 'undefined') {
        return array[index];
    }
}

export function findAny<T>(array: T[], predicate: (item: T, index: number) => boolean): boolean {
    return typeof findIndex(array, predicate) !== 'undefined';
}

export function filter<TIn, TOut extends TIn>(array: TIn[], predicate: (item: TIn) => boolean): TOut[] {
    const result: TOut[] = [];
    array.forEach(x => {
        if (predicate(x)) {
            result.push(x as any as TOut);
        }
    });
    return result;
}

export function objectToArray<T>(obj: { [key: string]: T }): T[] {
    const result: T[] = [];
    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            result.push(obj[key]);
        }
    }
    return result;
}

export function nthIndex(haystack: string, needle: string, occurrence: number): number {
    let i = -1;
    while (occurrence-- && i++ < haystack.length) {
        i = haystack.indexOf(needle, i);
        if (i < 0) break;
    }
    return i;
}

export function flatMap<TIn, TOut>(arr: TIn[], f: (x: TIn) => TOut[]) {
    return arr.reduce((result: TOut[], x) => result.concat(f(x)), []);
}

export function allEqual<T>(arr: T[], val: T): boolean {
    for (const x of arr) {
        if (x !== val) return false;
    }
    return true;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/services/arrays.ts